"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = require("react");
var VideoPlayerIds_1 = __importDefault(require("../../../VideoPlayerIds"));
var VideoProgressBar_1 = __importStar(require("../styles/VideoProgressBar"));
var VideoProgressedBar_1 = __importDefault(require("../styles/VideoProgressedBar"));
var ProgressBarCircle_1 = __importDefault(require("../styles/ProgressBarCircle"));
var RenderIf_1 = __importDefault(require("../../RenderIf"));
var ProgressBarContainer_1 = __importDefault(require("../styles/ProgressBarContainer"));
var VideoProgressBar = function (_a) {
    var controller = _a.controller, progress = _a.progress, progressedBarColor = _a.progressedBarColor, _b = _a.isCustomIntro, isCustomIntro = _b === void 0 ? false : _b, setInTransition = _a.setInTransition, _c = _a.isPreview, isPreview = _c === void 0 ? false : _c, changeToFirstVideo = _a.changeToFirstVideo, changeToSecondVideo = _a.changeToSecondVideo, playingSecondVideo = _a.playingSecondVideo, percentagePerVideo = _a.percentagePerVideo, gapCombinedVideoPlayer = _a.gapCombinedVideoPlayer;
    var _d = react_1.useState(VideoProgressBar_1.borderTypesEnum.ALL), borderRadiudSecondVideo = _d[0], setBorderRadiudSecondVideo = _d[1];
    var handleProgressBarClick = function (event) {
        var _a;
        if (playingSecondVideo) {
            setInTransition(true);
            changeToFirstVideo();
        }
        (_a = controller) === null || _a === void 0 ? void 0 : _a.handleProgressBarClick(event, false);
    };
    var handleProgressBar2Click = function (event) {
        var _a;
        if (!playingSecondVideo) {
            setInTransition(true);
            changeToSecondVideo();
        }
        // Big note, what about the down time?
        // update: seems to be working fine.
        (_a = controller) === null || _a === void 0 ? void 0 : _a.handleProgressBarClick(event, true);
    };
    // Controls the yellow animation
    var _e = react_1.useState("initial"), newVideo = _e[0], setNewVideo = _e[1];
    react_1.useEffect(function () {
        if (newVideo === "initial" && isCustomIntro) {
            setNewVideo("show");
            var timeOutId_1 = setTimeout(function () {
                setNewVideo("hide");
                clearTimeout(timeOutId_1);
            }, 2500);
        }
    }, [isCustomIntro]);
    react_1.useEffect(function () {
        setBorderRadiudSecondVideo(gapCombinedVideoPlayer ? VideoProgressBar_1.borderTypesEnum.ALL : VideoProgressBar_1.borderTypesEnum.LEFT);
    }, [gapCombinedVideoPlayer]);
    return (jsx_runtime_1.jsxs(ProgressBarContainer_1.default, __assign({ hasGap: gapCombinedVideoPlayer }, { children: [jsx_runtime_1.jsxs(VideoProgressBar_1.default, __assign({ id: VideoPlayerIds_1.default.ProgressBar, onClick: handleProgressBarClick, onMouseMove: controller === null || controller === void 0 ? void 0 : controller.handleProgressBarMouseMove, onMouseDown: controller === null || controller === void 0 ? void 0 : controller.handleProgressBarMouseDown, customIntro: isCustomIntro, barWidth: percentagePerVideo.firstVideo + "%", radiusSide: !isCustomIntro || gapCombinedVideoPlayer ? VideoProgressBar_1.borderTypesEnum.ALL : VideoProgressBar_1.borderTypesEnum.RIGHT }, { children: [jsx_runtime_1.jsx(VideoProgressedBar_1.default, { onClick: handleProgressBarClick, id: "first-video", progress: playingSecondVideo ? 100 : progress, color: progressedBarColor, radiusSide: !isCustomIntro || gapCombinedVideoPlayer || (!playingSecondVideo && progress < 100) ? VideoProgressBar_1.borderTypesEnum.ALL : VideoProgressBar_1.borderTypesEnum.RIGHT }, void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !playingSecondVideo }, { children: jsx_runtime_1.jsx(ProgressBarCircle_1.default, { id: "first-video", progress: progress * 2, color: progressedBarColor }, void 0) }), void 0)] }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !!isCustomIntro }, { children: jsx_runtime_1.jsxs(VideoProgressBar_1.default, __assign({ className: isPreview && newVideo === "show" ? "introduce" : "", id: VideoPlayerIds_1.default.ProgressBarCustomIntro, onClick: handleProgressBar2Click, onMouseMove: controller === null || controller === void 0 ? void 0 : controller.handleProgressBarMouseMove, onMouseDown: controller === null || controller === void 0 ? void 0 : controller.handleProgressBarMouseDown, customIntro: isCustomIntro, barWidth: percentagePerVideo.secondVideo + "%", radiusSide: borderRadiudSecondVideo }, { children: [jsx_runtime_1.jsx(VideoProgressedBar_1.default, { onClick: handleProgressBar2Click, id: "second-video", progress: playingSecondVideo ? progress : 0, color: progressedBarColor, radiusSide: borderRadiudSecondVideo }, void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !!playingSecondVideo }, { children: jsx_runtime_1.jsx(ProgressBarCircle_1.default, { id: "second-video", progress: progress * 2, color: progressedBarColor }, void 0) }), void 0)] }), void 0) }), void 0)] }), void 0));
};
exports.default = VideoProgressBar;
